<ftr-icon
  [icon]="'Timezone'"
  [align]="iconAlignment"
  [color]="color"
  [size]="'Medium'"
  [gapLeft]="gapLeft"
  ftrTooltip
  [template]="tooltip"
  [alignment]="tooltipAlignment"
  [showDash]="false"
>
</ftr-icon>

<ng-template #tooltip>
  <span>
    IANA Timezone
    <b>{{ timezone.toString() }}</b>
  </span>
</ng-template>
